



















import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { SmartAutocompletion } from '~/models/search-bar'
import { ciMagnifyingGlass } from '~/icons/source/solid/magnifying-glass'
import { ciArrowTop } from '~/icons/source/regular/arrow'

export default defineComponent({
  props: {
    completion: {
      type: Object as PropType<SmartAutocompletion>,
      required: true
    }
  },
  setup() {
    return {
      ciMagnifyingGlass,
      ciArrowTop
    }
  }
})
